import { IApiResponse, ISearchResponse } from '../../../common/models/common';
import request from '../../../utils/request';
import { IConfigDataRetention, ISearchConfigDataRetention } from './dataRetention.model';

// Steps come from the data retention deployment script: the API offers view and update only.
class ConfigDataRetentionService {
  ENDPOINT = '/config-data-retention';

  public async searchConfigDataRetention(
    searchParams?: ISearchConfigDataRetention
  ): Promise<IApiResponse<ISearchResponse<IConfigDataRetention>>> {
    const url = `${this.ENDPOINT}/search`;
    return request({ url, method: 'POST', data: searchParams }).then((res) => {
      return res.data;
    });
  }

  public async getConfigDataRetentionById(id: number): Promise<any> {
    const url = `${this.ENDPOINT}/${id}`;
    return request({ url, method: 'GET' }).then((res) => {
      return res.data;
    });
  }

  public async updateConfigDataRetention(data: IConfigDataRetention): Promise<any> {
    const {
      id,
      retention_months,
      is_enabled,
      exempt_company_ids,
      notes,
      batch_size,
      keep_latest_dataset,
    } = data;
    const url = `${this.ENDPOINT}/${id}`;
    return request({
      url,
      method: 'PUT',
      data: {
        retention_months,
        is_enabled,
        exempt_company_ids,
        notes,
        batch_size,
        keep_latest_dataset,
      },
    }).then((res) => {
      return res.data;
    });
  }

  // Header dropdown values for one column (own endpoint, not the generic /app/column-lookup).
  public async getColumnLookup(data: {}): Promise<any> {
    const url = `${this.ENDPOINT}/column-lookup`;
    return request({ url, method: 'POST', data }).then((res) => {
      return res.data?.body?.data ?? [];
    });
  }
}
export default new ConfigDataRetentionService();
